import React, {Fragment, useEffect, useState} from "react";
import Api from '../../interface/api/content/terms';
import {VisitorTermsInfo} from "../../interface/model/terms";

export function Policy({visitorInfo, setVisitorInfo, nextStepHandler}) {

    const [ visitorTermsInfos, setVisitorTermsInfos ] = useState<Array<VisitorTermsInfo>>([]);
    const [ termsInfos, setTermsInfos ] = useState([]);

    function nextStep() {
        if(isCheckRequiredAgree()) {
            // setVisitorInfo({...visitorInfo, visitorTermsInfos : visitorTermsInfos});
            nextStepHandler(visitorTermsInfos);
        } else
            alert('필수 약관을 동의해주세요.');
    }

    function isCheckRequiredAgree() {
        let agreeCheck = true;
        for(let i=0; i<termsInfos.length; i++) {
            let termsInfo = termsInfos[i];
            for(let k=0; k<visitorTermsInfos.length; k++) {
                let visitorTermsInfo = visitorTermsInfos[k];
                if(termsInfo.termsInfoSeq === visitorTermsInfo.termsInfoSeq) {
                    if(termsInfo.requiredFlag && !visitorTermsInfo.agreeFlag) {
                        agreeCheck = false;
                    }
                }
            }
        }
        return agreeCheck;
    }

    function onClickAllAgreeHandler(e) {
        let _tmpTermsInfos = new Array();
        termsInfos.map(row => _tmpTermsInfos.push({termsInfoSeq: row.termsInfoSeq, agreeFlag : e.target.checked }));
        setVisitorTermsInfos(_tmpTermsInfos);
    }

    function onClickAgreeHandler(termsInfo, e) {
        setVisitorTermsInfos(
            visitorTermsInfos
                .map(row =>
                    row.termsInfoSeq === termsInfo.termsInfoSeq
                        ? {...row, agreeFlag : e.target.checked}
                        : {...row}
                        ))
    }

    useEffect(() => {
        let siteInfo = JSON.parse(localStorage.getItem('siteInfo'));
        Api.getTermsInfos(siteInfo.seq).then(res => {
            setTermsInfos(res.data);
            let _arr = new Array();
            res.data.map(row => _arr.push({termsInfoSeq: row.termsInfoSeq, agreeFlag: false, visitorInfoSeq : null}));
            setVisitorTermsInfos(_arr);
        })
    }, [])

    return (
        <section id="step1" className="on">
            <div className="allcheck">
                <input type="checkbox" id='agree' className="agreeAllchk" onClick={onClickAllAgreeHandler}/>
                <label htmlFor='agree'>약관 전체 동의</label>
            </div>
            {
                termsInfos.map((row, index) => (
                    <div className="conbox" key={`termsKey-${index}`}>
                        <input type="checkbox"
                               id={`agree${index}`}
                               name="agree"
                               className="agreechk"
                               checked={visitorTermsInfos.filter(_row => row.termsInfoSeq === _row.termsInfoSeq && _row.agreeFlag).length > 0}
                               onClick={(e) => onClickAgreeHandler(row, e)}/>
                        <label htmlFor={`agree${index}`}>{row.title}</label>
                        <div className="nv_textarea" dangerouslySetInnerHTML={ {__html: row.contents} }></div>
                        {/* {index === 0 && <Privacy></Privacy>}
                        {index === 1 && <TermsOfService></TermsOfService>}
                        {index === 2 && <TermsOfService1></TermsOfService1>}
                        {index === 3 && <TermsOfService2></TermsOfService2>}
                        {index === 4 && <Security></Security>} */}
                    </div>
                ))
            }

            {/*<div className="conbox">*/}
            {/*    <input type="checkbox"*/}
            {/*           id='agree5'*/}
            {/*           name="agree"*/}
            {/*           className="agreechk"*/}
            {/*           checked={agree.filter(row => row === 'agree5').length > 0}*/}
            {/*           onClick={onClickAgreeHandler}/>*/}
            {/*    <label htmlFor='agree5'>방문 신청 약관 동의 [필수]</label>*/}
            {/*    <Privacy/>*/}
            {/*</div>*/}

            {/*<div className="conbox">*/}
            {/*    <input type="checkbox"*/}
            {/*           id='agree1'*/}
            {/*           name="agree"*/}
            {/*           className="agreechk"*/}
            {/*           checked={agree.filter(row => row === 'agree1').length > 0}*/}
            {/*           onClick={onClickAgreeHandler}/>*/}
            {/*    <label htmlFor='agree1'>개인정보 수집·이용 동의 [필수]</label>*/}
            {/*    <TermsOfService/>*/}
            {/*</div>*/}
            {/*<div className="conbox">*/}
            {/*    <input type="checkbox"*/}
            {/*           id='agree2'*/}
            {/*           name="agree"*/}
            {/*           className="agreechk"*/}
            {/*           checked={agree.filter(row => row === 'agree2').length > 0}*/}
            {/*           onClick={onClickAgreeHandler}/>*/}
            {/*    <label htmlFor='agree2'>개인정보 수집·이용 동의 [선택]</label>*/}
            {/*    <TermsOfService1/>*/}
            {/*</div>*/}
            {/*<div className="conbox">*/}
            {/*    <input type="checkbox"*/}
            {/*           id='agree3'*/}
            {/*           name="agree"*/}
            {/*           className="agreechk"*/}
            {/*           checked={agree.filter(row => row === 'agree3').length > 0}*/}
            {/*           onClick={onClickAgreeHandler}/>*/}
            {/*    <label htmlFor='agree3'>개인정보 제3자 제공 및 취급위탁에 대한 동의 [선택]</label>*/}
            {/*    <TermsOfService2/>*/}
            {/*</div>*/}
            {/*<div className="conbox">*/}
            {/*    <input type="checkbox"*/}
            {/*           id='agree4'*/}
            {/*           name="agree"*/}
            {/*           className="agreechk"*/}
            {/*           checked={agree.filter(row => row === 'agree4').length > 0}*/}
            {/*           onClick={onClickAgreeHandler}/>*/}
            {/*    <label htmlFor='agree4'>보안정책 및 안전수칙 동의 [필수]</label>*/}
            {/*    <Security/>*/}
            {/*</div>*/}

            <div className="nv_btn_area">
                {/*<button type="button" className="nv_btn_black">비동의</button>*/}
                <button type="button" className="nv_btn_blue" onClick={nextStep}>다음단계</button>
            </div>
        </section>
    )
}

export function Privacy() {
    return (
        <div className="nv_textarea">
            <p className="ls2 lh6 bs5 ts4">
                <em className="emphasis">솔브레인SLD 방문예약시스템('http://soulbrain.com'이하 '솔브레인SLD 방문예약시스템')</em>은(는) 「개인정보
                보호법」 제30조에 따라 정부주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
            </p>
            <p className="ls2">○ 이 개인정보처리방침은 <em className="emphasis">2021</em>년 <em
                className="emphasis">1</em>월 <em className="emphasis">1</em>부터 적용됩니다.
            </p>
            <br/>
            <p className='lh6 bs4'>
                <strong>제1조(개인정보의 처리 목적)
                    <br/><br/>
                    <em className="emphasis">솔브레인SLD 방문예약시스템('http://soulbrain.com'이하 '솔브레인SLD 방문예약시스템')</em>
                    은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고
                    있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며 이용 목적이 변경되는 겨우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한
                    조치를 이행할 예정입니다.
                </strong>
            </p>
            <ul className="list_indent2 mgt10">
                <p className="ls2">1. 홈페이지 회원가입 및 관리</p>
                <p className="ls2">회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만14세 미만 아동의
                    개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지·통지, 고충처리 목적으로 개인정보를 처리합니다.</p>
                <br/>
                <p className="ls2">2. 민원사무 처리</p>
                <p className="ls2">민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보 목적으로 개인정보를 처리합니다.</p>
                <br/>
                <p className="ls2">3. 재화 또는 서비스 제공</p>
                <p className="ls2">서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산을 목적으로 개인정보를
                    처리합니다.</p>
                <br/>
                <p className="ls2">4. 마케팅 및 광고에의 활용</p>
                <p className="ls2">이벤트 및 광고성 정보 제공 및 참여기회 제공 등을 목적으로 개인정보를 처리합니다.</p>
                <br/>
                <p className="ls2">5. 개인영상정보</p>
                <p className="ls2">범죄의 예방 및 수사, 시설안전 및 화재예방, 교통단속, 교통정보의 수집·분석 및 제공 등을 목적으로 개인정보를 처리합니다.</p>
                <br/>
            </ul>
        </div>
    )
}

export function TermsOfService() {
    return (
        <div className="nv_textarea">
            <p className='lh6 bs4'>
                <strong>개인정보 수집 및 이용 동의[필수]</strong>
            </p>
            <ul className="list_indent2 mgt10">
                <p className="ls2">목적 : - 사업장 방문예약 신청 - 사업장 방문 이후 사고 발생 시 확인 및 관련 조치 실시</p>
                <p className="ls2">항목 : 성명, 생년월일, 휴대전화번호, 회사명, 소속</p>
                <p className="ls2">보유기간 : 개인정보 수집 및 이용에 동의한 날로부터 1년까지</p>
                <p className="ls2">※ 방문객은 위 개인정보 수집 및 이용에 대한 동의를 거부할 수 있습니다. 다만, 방문객이 위 개인정보의 수집 및 이용에 대해 동의하지 않는 경우에는 사업장 출입이 제한될 수 있습니다.</p>
            </ul>
        </div>
    )
}
export function TermsOfService1() {
    return (
        <div className="nv_textarea">
            <p className='lh6 bs4'>
                <strong>개인정보 수집 및 이용 동의[선택]</strong>
            </p>
            <ul className="list_indent2 mgt10">
                <p className="ls2">목적 : - 사업장 방문예약 신청 - 사업장 방문 이후 사고 발생 시 확인 및 관련 조치 실시</p>
                <p className="ls2">항목 : 차량번호</p>
                <p className="ls2">보유기간 : 개인정보 수집 및 이용에 동의한 날로부터 1년까지</p>
                <p className="ls2">※ 방문객은 위 개인정보 수집 및 이용에 대한 동의를 거부할 수 있습니다. 다만, 방문객이 위 개인정보의 수집 및 이용에 대해 동의하지 않는 경우에는 회사 사업장 내 차량을 주차하실 수 없습니다.</p>
            </ul>
        </div>
    )
}
export function TermsOfService2() {
    return (
        <div className="nv_textarea">
            <p className='lh6 bs4'>
                <strong>개인정보의 제3자 제공 및 취급위탁에 대한 동의[필수]</strong>
            </p>
            <ul className="list_indent2 mgt10">
                <p className="ls2">제공 및 위탁업체 : 솔브레인SLD(주) / 041)851-4500</p>
                <p className="ls2">목적 : 방문 등록 시스템 운영 및 유지 보수</p>
                <p className="ls2">항목 : 성명, 생년월일, 휴대전화번호</p>
                <p className="ls2">※ 방문객은 위 개인정보의 제3자 제공 및 처리위탁에 대한 동의를 거부할 수 있습니다.</p>
            </ul>
        </div>
    )
}

export function Security() {
    return (
        <div className="nv_textarea">
            <p className='lh6 bs4'>
                <strong>보안정책 및 안전수칙 동의</strong>
            </p>
            <ul className="list_indent2 mgt10">
                <p className="ls2">1. 사업장 방문 시 신분증을 지참하지 않을 경우 출입이 제한될 수 있으며, 업무 시간에 한하여 출입이 가능합니다.</p>
                <p className="ls2">2. 휴대폰 보안스티커는 반드시 부착하여야 하며, 전 사업장 내 촬영 및 녹음은 절대 불가 합니다.<br/>(보안스티커 제거 시 사안에 따라 법적 조치를 취할 수 있습니다.)</p>
                <p className="ls2">3. 사업장 내에서 출입증을 상시 패용해야 하며, 이동 시 반드시 주관부서 담당자와 동행해야 합니다.</p>
                <p className="ls2">4. 회사의 교통안전수칙을 준수합니다.(사내 차량 이동 시 규정속도 30km/h, 오토바이 이동 시 헬멧착용, 횡단보도 이용 등)</p>
                <p className="ls2">5. 사업장 내 지정된 흡연구역 외 어떠한 장소에도 흡연을 금지 합니다.</p>
                <p className="ls2">6. 사내 시설물 등 사용 시 주관부서의 허락을 득한 후 사용하고, 사용 후 반드시 원상회복(정리/정돈)해야 합니다.</p>
                <p className="ls2">※ 상기 내용을 철저히 준수하고 상기 내용 불이행에 따른 문제 발생 시 어떠한 불이익도 감수 하겠습니다.</p>
            </ul>
        </div>
    )
}
